import { customGetProductCollectionRealTimePrices } from "@crescentParts/Services/SelectedWarehousePricingService";
import { Handler, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { GetProductCollectionRealTimePriceApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

const myListsDetailsPath = "/myaccount/mylists/details";
const pageQueryStringKey = "page";
const myListDetailsPageQueryStringValue = "mylistdetails";
const warehouseQueryStringKey = "wh";

type Parameter = GetProductCollectionRealTimePriceApiV2Parameter &
    HasOnSuccess<RealTimePricingModel> &
    HasOnError<unknown>;

type Props = {
    apiResult: RealTimePricingModel;
    apiParameter: GetProductCollectionRealTimePriceApiV2Parameter;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiWithWarehouseQuery: HandlerType = async props => {
    if (!getSettingsCollection(props.getState()).productSettings.canSeePrices) {
        return false;
    }

    if (typeof window !== "undefined" && window.location.pathname.toLowerCase().includes(myListsDetailsPath)) {
        const warehouse = new URLSearchParams(window.location.search).get(warehouseQueryStringKey);
        props.apiParameter.additionalQueryStringParameters = {
            ...(props.apiParameter.additionalQueryStringParameters ?? {}),
            [pageQueryStringKey]:
                props.apiParameter.additionalQueryStringParameters?.[pageQueryStringKey] ?? myListDetailsPageQueryStringValue,
        };

        if (warehouse) {
            props.apiParameter.additionalQueryStringParameters = {
                ...(props.apiParameter.additionalQueryStringParameters ?? {}),
                [warehouseQueryStringKey]: props.apiParameter.additionalQueryStringParameters?.[warehouseQueryStringKey] ?? warehouse,
            };
        }
    }

    try {
        props.apiResult = await customGetProductCollectionRealTimePrices(props.apiParameter);
    } catch (error) {
        const apiError = error as { status?: number; errorJson?: unknown };
        if (apiError.status === 403) {
            apiError.status = 401;
            apiError.errorJson = { message: "error" };
            throw error;
        }

        logger.warn(`Failed to load pricing data: ${error}`);
        props.error = error;
    }
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiWithWarehouseQuery);